import type { MonthlyTrend } from '../../../hooks/useAdvancedInsights';

interface Props { trends: MonthlyTrend[]; }

const fmt = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const InsightsHistoryChart = ({ trends }: Props) => {
  if (!trends.length) return null;

  const maxVal = Math.max(...trends.flatMap(t => [t.receitas, t.despesas]), 1);

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-xl">
          <i className="ri-line-chart-line text-teal-500 text-[16px]" />
        </div>
        <div>
          <h2 className="text-[15px] font-700 text-gray-900">Histórico dos Últimos 6 Meses</h2>
          <p className="text-[12px] text-gray-400">Evolução de receitas, despesas e saldo</p>
        </div>
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <div className="flex items-end gap-2 h-40 mb-3">
          {trends.map((t) => (
            <div key={t.label} className="flex-1 flex flex-col items-center gap-1">
              <div className="w-full flex items-end gap-0.5 h-32 justify-center">
                <div
                  className="flex-1 rounded-t-lg bg-emerald-400 transition-all"
                  style={{ height: `${maxVal > 0 ? (t.receitas / maxVal) * 100 : 0}%`, minHeight: t.receitas > 0 ? '4px' : '0' }}
                  title={`Receitas: ${fmt(t.receitas)}`}
                />
                <div
                  className="flex-1 rounded-t-lg bg-red-400 transition-all"
                  style={{ height: `${maxVal > 0 ? (t.despesas / maxVal) * 100 : 0}%`, minHeight: t.despesas > 0 ? '4px' : '0' }}
                  title={`Despesas: ${fmt(t.despesas)}`}
                />
              </div>
              <p className="text-[10px] text-gray-400 font-500">{t.month}</p>
            </div>
          ))}
        </div>
        <div className="flex items-center gap-4 mt-2">
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 bg-emerald-400 rounded-sm" />
            <span className="text-[11px] text-gray-500">Receitas</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 bg-red-400 rounded-sm" />
            <span className="text-[11px] text-gray-500">Despesas</span>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-50 grid grid-cols-3 sm:grid-cols-6 gap-2">
          {trends.map((t) => (
            <div key={t.label + '-sum'} className="text-center">
              <p className="text-[10px] text-gray-400 mb-0.5">{t.label}</p>
              <p className={`text-[11px] font-700 ${t.saldo >= 0 ? 'text-emerald-600' : 'text-red-500'}`}>
                {t.saldo >= 0 ? '+' : ''}{fmt(t.saldo)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
